import type { EreRecipientDto, NotificationDto } from 'korint-sdk';

type Ar24Recipient = Partial<
  Record<'to_email' | 'to_firstname' | 'to_lastname' | 'to_company', string>
>;

// EREs sent before the recipient columns existed only have AR24's copy of the recipient.
export const sentRecipient = ({
  recipientEmail,
  recipientFirstName,
  recipientLastName,
  recipientCompany,
  metadata,
}: NotificationDto): EreRecipientDto => {
  const ar24 = (metadata ?? {}) as Ar24Recipient;
  return {
    email: recipientEmail ?? ar24.to_email ?? '',
    firstName: recipientFirstName ?? ar24.to_firstname ?? '',
    lastName: recipientLastName ?? ar24.to_lastname ?? '',
    company: recipientCompany ?? (ar24.to_company || undefined),
  };
};
